import { Suspense, FC } from 'react';
import CustomsMessagingRenderer, {
    CustomsMessagingRendererProps,
} from './CustomsMessagingRenderer';

const CustomsMessaging: FC<CustomsMessagingRendererProps> = props => {
    const { userId } = props;
    return userId ? (
        <Suspense>
            <CustomsMessagingRenderer {...props} />
        </Suspense>
    ) : null;
};

export default CustomsMessaging;
